/**
 * 机构管理api
 */
import {axiosPost} from "@/utils/request";


export const newGetSimpleTress = () => {
  return new Promise((resolve, reject) => {
    axiosPost({
      url: '/ap-system/selectOrganization',
      loading: false
    }).then(resData => {
      resolve(resData)

    })
  })
}


